export const shortenNumber = (number) => {
    const units = ['K', 'M', 'B', 'T']; // Тысяча, миллион, миллиард, триллион
    let unitIndex = -1;

    // Если число меньше 1000, то просто возвращаем его в исходном виде
    if (number < 1000) return number;

    while (number >= 1000) {
        number /= 1000;
        unitIndex++;
    }

    // Округляем число до 2 знаков после запятой
    const shortened = number.toFixed(2);
    return `${shortened}${units[unitIndex] || ''}`;
};
